import React, { ReactElement } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  chakra,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { Link as GatsbyLink } from "gatsby";
import { TutorialImage } from "../Tutorials";

export const HomePageProgressButton: React.FC<{ to: string }> = ({ to }) => {
  const linkColor = useColorModeValue("blue.500", "orange.400");
  return (
    <Button
      as={GatsbyLink}
      to={to}
      color={linkColor}
      rightIcon={<FiArrowRight />}
      variant="link"
      size="lg"
    >
      Resume progress
    </Button>
  );
};

type HomePageProgressCardProps = {
  type?: string;
  title: string;
  subtitle?: string;
  children: ReactElement;
  thumb: {
    src?: string | null;
    alt?: string | null;
  } | null;
};

export function HomePageProgressCard({
  type = "Course",
  title,
  subtitle,
  thumb,
  children,
}: HomePageProgressCardProps) {
  const bg = useColorModeValue("silver.100", "black.100");
  return (
    <Flex
      direction="column"
      align={{ base: "center", md: "stretch" }}
      textAlign={{ base: "center", md: "left" }}
      p={{ base: 6, md: 10 }}
      bg={bg}
    >
      <chakra.h2 mb={{ base: 1, md: 2 }} textStyle="smallCaps">
        {type} in progress
      </chakra.h2>
      <Heading as="h3" mb={{ base: 4, md: 6 }}>
        {title}
      </Heading>
      <Flex>
        <TutorialImage
          flexShrink={0}
          w={9 / 16}
          mr="8"
          d={{ base: "none", md: "flex" }}
          {...thumb}
        />
        <div>
          <Box d={{ base: "none", md: "block" }}>
            {subtitle && (
              <Heading size="md" as="h4" mb="1">
                {subtitle}
              </Heading>
            )}
            <Text fontSize="lg" mb="6">
              You’re doing great so far! Keep the learning momentum going by
              picking up where you left off.
            </Text>
          </Box>
          {children}
        </div>
      </Flex>
    </Flex>
  );
}
